// Single-row rolling logo gallery. One direction, big thumbnails.
import { useTheme } from "../context/ThemeContext";

const RollingRow = ({ items, direction = "left", speed = 40, tileSize = 96 }) => {
  const { isDark } = useTheme();
  // Duplicate for seamless loop
  const strip = [...items, ...items];
  return (
    <div className="relative overflow-hidden" style={{
      maskImage: "linear-gradient(to right, transparent 0, black 5%, black 95%, transparent 100%)",
      WebkitMaskImage: "linear-gradient(to right, transparent 0, black 5%, black 95%, transparent 100%)",
    }}>
      <div
        className="flex gap-4"
        style={{
          animation: `roll-${direction} ${speed}s linear infinite`,
          width: "fit-content",
        }}
      >
        {strip.map((it, i) => (
          <div
            key={i}
            className={`flex-shrink-0 rounded-2xl overflow-hidden border ${
              isDark ? "border-white/10" : "border-black/[0.08]"
            }`}
            style={{ width: tileSize * 1.6, height: tileSize }}
          >
            {it.image ? (
              <img
                src={it.image}
                alt={it.name}
                loading="lazy"
                className="w-full h-full object-cover block"
              />
            ) : (
              <div className={`w-full h-full flex items-center justify-center ${isDark ? "bg-white/[0.04]" : "bg-white"}`}>
                <span className={`text-[13px] font-medium ${isDark ? "text-white/70" : "text-black/60"}`}>{it.name}</span>
              </div>
            )}
          </div>
        ))}
      </div>
      <style>{`
        @keyframes roll-left {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @keyframes roll-right {
          from { transform: translateX(-50%); }
          to { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};

export default RollingRow;
